import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useFormatNodeTaskType = () => {
  const { t } = useTranslation();

  const formatNodeTaskType = useCallback(
    (node: { taskType: string }, isSmall?: boolean) =>
      isSmall ? node.taskType.slice(0, 2) : t(['products.productionPlan.taskTypes', node.taskType].join('.')),
    [t],
  );

  return formatNodeTaskType;
};
